<template>
  <div class="simple-moderation-decision">
    <div v-if="data.status !== 'Модерация отклонена'" class="decision-part">
      <p-radio
        v-model="typeDecision"
        label="completed"
        class="confirm-radio"
        :disabled="disableRadio('completed')">
        Подтвердить
      </p-radio>
      <p-radio
        v-model="typeDecision"
        label="reject"
        class="reject-radio"
        :disabled="disableRadio('reject')">
        {{ rejectTextBtn }}
      </p-radio>
      <p-radio
        v-model="typeDecision"
        label="failed"
        class="fail-radio"
        :disabled="disableRadio('failed')">
        Провалить
      </p-radio>
    </div>
    <div class="comment" :class="{visible: showComment || showCommentInput}">
      <transition name="fade" mode="out-in">
        <div v-if="showCommentInput && !disableRadios" key="input" class="comment-input">
          <div class="info-title">
            <img v-if="flagIconSrc" :src="flagIconSrc" alt="">
            {{ commentInputTitle }}
          </div>
          <fg-input
            type="text"
            class="textarea-7-rows"
            name="Комментарий">
            <textarea
              v-model="actualComment"
              class="form-control custom-scroll"/>
          </fg-input>
          <el-tooltip
            v-if="data.initComment || actualComment"
            :key="actualComment ? 'clear' : 'paste'"
            :disabled="isNarrowScreen"
            popper-class="paste-comment-tooltip"
            :content="actualComment ? 'Очистить комментарий' : 'Вставить текст прошлого комментария'"
            placement="left">
            <div class="paste-comment-btn" @click="handlePasteBtnClick">
              <el-icon>
                <component :is="chatIcon"/>
              </el-icon>
            </div>
          </el-tooltip>
        </div>
        <div v-else-if="showComment" key="info" class="comment-info">
          <div class="info-title">
            <i class="fa fa-info-circle"/>
            Модерация ранее была {{ rejectComment }} с комментарием:
          </div>
          <div class="info-text">
            {{ data.initComment }}
          </div>
        </div>
      </transition>
    </div>
    <el-alert
      v-if="typeDecision === 'failed'"
      title="Текущее задание будет провалено"
      type="warning"
      :closable="false"/>
  </div>
</template>

<script>
import { ElTooltip, ElAlert } from 'element-plus'
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "SimpleModerationActionPart",
  components: {
    ElTooltip,
    ElAlert
  },
  inject: ["mq"],
  props: {
    data: Object
  },
  data:() => ({
    actualComment: ''
  }),
  computed: {
    ...mapGetters(['selectedTask']),
    ...mapGetters({
      user: 'selectedUser',
    }),
    typeDecision: {
      get() {
        return this.data.decision
      },
      set(value) {
        this.$emit('change-decision', value)
      }
    },
    showCommentInput() {
      const isRejected = this.data.status === 'Модерация отклонена'
      const rejectSelected = this.data.decision === 'reject'
      return isRejected || rejectSelected
    },
    showComment() {
      return this.data.status === 'Не проверена' && this.data.initComment
    },
    commentInputTitle() {
      const langStr = {
        en: 'английском',
        ru: 'русском'
      }[this.interfaceLang]
      return `Комментарий о причине отклонения (на ${langStr} языке)`
    },
    isNarrowScreen() {
      return this.mq.current === 'xs'
    },
    flagIconSrc() {
      return {
        en: '/static/img/flags/128/United-Kingdom.png',
        ru: '/static/img/flags/128/Russian-Federation.png'
      }[this.interfaceLang]
    },
    interfaceLang() {
      return this.user ? this.user.interface_language : 'ru'
    },
    chatIcon() {
      return this.actualComment ? 'Delete' : 'ChatRound'
    },
    disableRadios() {
      if (!this.data.isCreAso) return
      return this.selectedTask.status.name === 'revision' && this.data.initComment
    },
    rejectTextBtn() {
      return this.data.isCreAso ? 'Доработка' : 'Отклонить'
    },
    rejectComment() {
      return this.data.isCreAso ? 'отправлена на доработку' : 'отклонена'
    }
  },
  watch: {
    actualComment(value) {
      this.$emit('change-comment', value)
    },
  },
  methods: {
    handlePasteBtnClick() {
      this.actualComment = this.actualComment ? '' : this.data.initComment
    },
    disableRadio(type) {
      if (!this.data.isCreAso || !['revision', 'completed', 'failed'].includes(this.selectedTask.status.name)) return
      const diffTime = Math.floor(moment(this.selectedTask.complete_at).diff(moment(this.selectedTask.started_at)) / 1000)
      if (this.data.initDecision === 'failed' && ['reject', 'failed'].includes(type) && diffTime > this.selectedTask.task_time) return
      return type !== this.data.decision
    }
  },
  beforeMount() {
    if (this.data.status === 'Модерация отклонена') {
      this.actualComment = this.data.initComment
    }
  },
}
</script>

<style scoped>

</style>
